import { useMutation } from "@tanstack/react-query";
import { removeLogo, RemoveLogoPayload } from "PFCore/services/accounts/remove_logo";

export const useRemoveAccountLogo = () =>
  useMutation({ mutationFn: (data: RemoveLogoPayload) => removeLogo(data) });
